import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsGraphHistoryToggle;
(function (NsGraphHistoryToggle) {
    /** Command: 用于注册named factory */
    NsGraphHistoryToggle.command = XFlowGraphCommands.GRAPH_HISTORY_TOGGLE;
    /** hookName */
    NsGraphHistoryToggle.hookKey = 'historyToggle';
})(NsGraphHistoryToggle || (NsGraphHistoryToggle = {}));
let GraphHistoryToggleCommand = class GraphHistoryToggleCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.historyToggle.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                if (graph.isHistoryEnabled() === false) {
                    return {
                        err: 'history is disabled',
                    };
                }
                const isEnable = graph.isHistoryEnabled();
                const { enabled } = handlerArgs;
                // 执行graph命令
                graph.toggleHistory(enabled);
                // 添加undo
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    const { commandService } = handlerArgs;
                    commandService.executeCommand(XFlowGraphCommands.GRAPH_HISTORY_TOGGLE.id, {
                        enabled: isEnable,
                    });
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphHistoryToggleCommand.prototype, "contextProvider", void 0);
GraphHistoryToggleCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphHistoryToggle.command.id },
    })
    /** 创建节点命令 */
], GraphHistoryToggleCommand);
export { GraphHistoryToggleCommand };
//# sourceMappingURL=graph-history-toggle.js.map